/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["img[_ngcontent-%COMP%]{max-width:100%;max-height:750px;border:1px solid #ececec}.lightbox-date[_ngcontent-%COMP%]{position:absolute;left:8px;bottom:8px;display:flex;align-items:center;gap:6px;background-color:rgba(0,0,0,.65);color:#fff;padding:4px 10px;border-radius:4px;font-size:.8rem}.lightbox-date[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:.9rem;width:.9rem;height:.9rem}"];
export { styles as styles };
